import { get, post, put, del } from "../../httpClients/clients/http.client";
import {
  SignupInput,
  LoginInput,
  AuthResponse,
  MeResult,
  PublicUser,
  UpdateBasicInfoInput,
} from "@/dashboard-api-types/api/auth.types";

const BASE_PATH = "/auth";

export const AuthApi = {
  signupAdmin: (data: SignupInput, accessToken: string): Promise<boolean> =>
    post<boolean>(`${BASE_PATH}/signup/admin`, data, { headers: getAuthHeader(accessToken) }),
  signupAsk: (data: SignupInput): Promise<boolean> =>
    post<boolean>(`${BASE_PATH}/signup/ask`, data),
  login: (data: LoginInput): Promise<AuthResponse> =>
    post<AuthResponse>(`${BASE_PATH}/login`, data),
  refreshSession: (): Promise<AuthResponse> => post<AuthResponse>(`${BASE_PATH}/refresh`),
  logout: (): Promise<void> => post(`${BASE_PATH}/logout`),
  me: (accessToken?: string, signal?: AbortSignal): Promise<MeResult> =>
    get<MeResult>(`${BASE_PATH}/me`, { headers: getAuthHeader(accessToken), signal }),
  listUsers: async (accessToken: string, signal?: AbortSignal): Promise<PublicUser[]> => {
    const result = await get<{ users: PublicUser[] }>(`${BASE_PATH}/users`, {
      headers: getAuthHeader(accessToken),
      signal,
    });
    return result.users;
  },
  updatePassword: (
    userId: string,
    newPassword: string,
    accessToken: string
  ): Promise<AuthResponse> =>
    put(
      `${BASE_PATH}/update-password/${userId}`,
      { newValue: newPassword },
      { headers: getAuthHeader(accessToken) }
    ),
  updateBasicInfo: (
    userId: string,
    data: UpdateBasicInfoInput,
    accessToken: string
  ): Promise<boolean> =>
    put(`${BASE_PATH}/update-basic-info/${userId}`, data, { headers: getAuthHeader(accessToken) }),
  deleteUser: (userId: string, accessToken: string): Promise<boolean> =>
    del(`${BASE_PATH}/delete-user/${userId}`, {
      headers: getAuthHeader(accessToken),
    }),
};

function getAuthHeader(token: string) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}
